module.exports = __webpack_public_path__ + "img/t2-15.5d2e7f6a.svg";